angular.module('admin.politics', [
  'admin.politics.index',
  'admin.politics.add'
]);



// WEBPACK FOOTER //
// ./client/src/app/admin/politics/index.js